import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Copy } from "lucide-react";
import { env } from "@/env";
import { getLoginUrl } from "@/lib/utils/login-url";
export function ConfirmationModal(t0) {
  const $ = _c(61);
  const {
    isOpen,
    onClose,
    companyName,
    email,
    websiteDomain
  } = t0;
  const t = useTranslations("home.signUp.form.confirmation");
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== websiteDomain) {
    t1 = async () => {
      if (websiteDomain) {
        ;
        try {
          await navigator.clipboard.writeText(websiteDomain);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch (t2) {
          const err = t2;
          console.error("Failed to copy URL:", err);
        }
      }
    };
    $[0] = websiteDomain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopyUrl = t1;
  const basePath = env.NEXT_PUBLIC_BASE_PATH || "";
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== companyName || $[3] !== copied || $[4] !== email || $[5] !== handleCopyUrl || $[6] !== isOpen || $[7] !== onClose || $[8] !== t || $[9] !== websiteDomain) {
    const adminSetupUrl = websiteDomain ? getLoginUrl({
      domain: websiteDomain,
      basePath,
      redirect: "/dashboard"
    }) : "";
    T1 = Dialog;
    t8 = isOpen;
    t9 = onClose;
    T0 = DialogContent;
    t6 = "sm:max-w-md";
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100"><CheckCircle className="h-6 w-6 text-green-600" /></div>;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t) {
      t11 = t("title");
      $[21] = t;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    if ($[23] !== t11) {
      t7 = <DialogHeader className="text-center">{t10}<DialogTitle className="text-xl font-semibold">{t11}</DialogTitle></DialogHeader>;
      $[23] = t11;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    t2 = "space-y-3 text-center";
    let t12;
    if ($[25] !== companyName || $[26] !== t) {
      t12 = t("message", {
        companyName
      });
      $[25] = companyName;
      $[26] = t;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    if ($[28] !== t12) {
      t3 = <p className="text-muted-foreground text-sm">{t12}</p>;
      $[28] = t12;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    let t13;
    if ($[30] !== email || $[31] !== t) {
      t13 = t("credentialsMessage", {
        email
      });
      $[30] = email;
      $[31] = t;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    if ($[33] !== t13) {
      t4 = <p className="text-sm font-medium text-green-600">{t13}</p>;
      $[33] = t13;
      $[34] = t4;
    } else {
      t4 = $[34];
    }
    t5 = websiteDomain ? <div className="space-y-2"><p className="text-sm font-medium text-gray-700">{t("websiteMessage")}</p><div className="flex items-center justify-center gap-2 rounded-lg bg-gray-50 p-3"><code className="font-mono text-sm text-blue-600">{websiteDomain}</code><Button variant="ghost" size="sm" onClick={handleCopyUrl} className="h-6 w-6 p-0" data-testid="copyButton"><Copy className="h-3 w-3" /></Button>{copied && <span className="text-xs text-green-600">Copied!</span>}</div><p className="text-sm text-blue-600">{t("accessMessage", {
          adminSetupUrl
        })}</p></div> : <div className="space-y-2"><p className="text-sm font-medium text-orange-600">{t("websiteSetupMessage")}</p><p className="text-sm text-gray-600">{t("emailNotificationMessage")}</p></div>;
    $[2] = companyName;
    $[3] = copied;
    $[4] = email;
    $[5] = handleCopyUrl;
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = t;
    $[9] = websiteDomain;
    $[10] = T0;
    $[11] = T1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[10];
    T1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[35] !== t) {
    t10 = t("description");
    $[35] = t;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10) {
    t11 = <p className="text-muted-foreground text-sm">{t10}</p>;
    $[37] = t10;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t11 || $[40] !== t2 || $[41] !== t3 || $[42] !== t4 || $[43] !== t5) {
    t12 = <div className={t2}>{t3}{t4}{t5}{t11}</div>;
    $[39] = t11;
    $[40] = t2;
    $[41] = t3;
    $[42] = t4;
    $[43] = t5;
    $[44] = t12;
  } else {
    t12 = $[44];
  }
  let t13;
  if ($[45] !== t) {
    t13 = t("closeButton");
    $[45] = t;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== onClose || $[48] !== t13) {
    t14 = <div className="flex justify-center pt-4"><Button onClick={onClose}>{t13}</Button></div>;
    $[47] = onClose;
    $[48] = t13;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== T0 || $[51] !== t12 || $[52] !== t14 || $[53] !== t6 || $[54] !== t7) {
    t15 = <T0 className={t6}>{t7}{t12}{t14}</T0>;
    $[50] = T0;
    $[51] = t12;
    $[52] = t14;
    $[53] = t6;
    $[54] = t7;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== T1 || $[57] !== t15 || $[58] !== t8 || $[59] !== t9) {
    t16 = <T1 open={t8} onOpenChange={t9}>{t15}</T1>;
    $[56] = T1;
    $[57] = t15;
    $[58] = t8;
    $[59] = t9;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  return t16;
}